import api  from './api';
import { Post, CreatePostDto, UpdatePostDto, PostListDto, PostFilter } from '../types/post';

export const postsService = {
  async getPosts(filters?: PostFilter): Promise<PostListDto> {
    const params = new URLSearchParams();
    
    if (filters?.cityId) params.append('cityId', filters.cityId);
    if (filters?.authorType !== undefined) params.append('authorType', filters.authorType.toString());
    if (filters?.status !== undefined) params.append('status', filters.status.toString());
    if (filters?.pageSize) params.append('pageSize', filters.pageSize.toString());
    if (filters?.cursor) params.append('cursor', filters.cursor);

    const response = await api.get(`/admin/posts?${params.toString()}`);
    return response.data;
  },

  async getPostById(id: string): Promise<Post> {
    const response = await api.get(`/admin/posts/${id}`);
    return response.data;
  },

  async createPost(data: CreatePostDto): Promise<Post> {
    const response = await api.post('/admin/posts', data);
    return response.data;
  },

  async updatePost(id: string, data: UpdatePostDto): Promise<Post> {
    const response = await api.put(`/admin/posts/${id}`, { ...data, id });
    return response.data;
  },

  async deletePost(id: string): Promise<void> {
    await api.delete(`/admin/posts/${id}`);
  },

  async canManagePost(id: string): Promise<boolean> {
    const response = await api.get(`/admin/posts/${id}/can-manage`);
    return response.data.canManage;
  }
};
